var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 22,
    viewBox: "0 0 104 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72437 7.85716V7.33333H8.99544V7.85716H9.98861V8.90479L11.0398 8.9048V11H8.93719V10.4568H6.83417V11H4.73134V10.4762H3.67995V8.38096H4.73134V7.85716H5.72437Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2618 7.33333V7.85716H22.2549V8.38096H23.3063V10.4762H22.2549V11H20.152V10.4568H18.049V11H15.9465V8.9048H16.9978L16.9976 7.85716H17.9908V7.33333H21.2618Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22665 14.6667V20.7778H0V3.66667H1.22665V2.44444H3.67995V1.22222L6.13325 1.22222V0H20.8531V1.22222L23.3064 1.22222V2.44444H25.7597V3.66667H26.9863V20.7778H25.7597V14.6667H24.533V15.2099H23.3064V15.8889H21.4664V17.1111H19.0131V18.3333H17.1731V18.8765H9.81321V18.3333H7.97323V17.1111H5.51993V15.8889H3.67995V15.2099H2.4533V14.6667H1.22665ZM19.6264 1.22222V2.44444H22.0797V3.66667H24.533V4.88889H25.7597V11.5432H24.533V12.7654H23.3064V13.4444H20.8531V14.6667H18.3998V15.3457H15.9465V15.8889H11.0399V15.3457H8.58655V14.6667H6.13325V13.4444H3.67995V12.7654H2.4533V11.5432H1.22665V4.88889H2.4533V3.66667H4.9066V2.44444H7.3599V1.22222H19.6264Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7597 20.7778V22H1.22665L1.22665 20.7778H25.7597Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9754 1.43009H39.0076V17.6366H47.1402V19.6795H34.9754V1.43009Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7669 5.51582H95.799V15.5938H99.9678V5.51582H104V19.6795H102.018V21.7224H93.8171V19.6795H99.9678V17.6367H93.8171V15.5938H91.7669V5.51582Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6022 3.47296H83.6343V7.49055H89.7851V9.53339H83.6343V17.6367H87.7348V19.6795H81.6524V17.6367H79.6022V9.53339H77.4836V7.49055H79.6022V3.47296Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2407 5.51582H59.305V7.55867H61.2869V17.6367H59.305V19.6795H51.2407V17.6367H49.1905V7.55867H51.2407V5.51582ZM53.2226 7.55867H57.2548V17.6367H53.2226V7.55867Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4514 5.51582H65.3871V7.55867H63.3369V17.6367H65.3871V19.6795H73.4514V17.6367H75.4333V7.55867H73.4514V5.51582ZM71.4012 7.55867H67.369V17.6367H71.4012V7.55867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.08e2bf9e6d480d3105efdf971dcab22f.svg";
export { ForwardRef as ReactComponent };